import { defaultTheme } from '@nxsys/constants/defaultConfig';
import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMailClock: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = defaultTheme.theme.palette.brand,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6253 15.834C10.6253 16.179 10.3453 16.459 10.0003 16.459H4.16699C2.15199 16.459 1.04199 15.349 1.04199 13.334V5.83398C1.04199 3.81898 2.15199 2.70898 4.16699 2.70898H14.167C16.182 2.70898 17.292 3.81898 17.292 5.83398V9.16732C17.292 9.51232 17.012 9.79232 16.667 9.79232C16.322 9.79232 16.042 9.51232 16.042 9.16732V5.83398C16.042 4.51982 15.4812 3.95898 14.167 3.95898H4.16699C2.85283 3.95898 2.29199 4.51982 2.29199 5.83398V13.334C2.29199 14.6482 2.85283 15.209 4.16699 15.209H10.0003C10.3453 15.209 10.6253 15.489 10.6253 15.834ZM13.3829 6.16232L9.28947 9.13899C9.21614 9.19149 9.11866 9.19149 9.04533 9.13899L4.9519 6.16232C4.67107 5.95815 4.28119 6.02232 4.07869 6.29982C3.87536 6.57899 3.93706 6.97065 4.21623 7.17315L8.30945 10.1498C8.56612 10.3365 8.86699 10.4298 9.16699 10.4298C9.46699 10.4298 9.7687 10.3365 10.0245 10.1498L14.1178 7.17315C14.3969 6.97065 14.4586 6.57899 14.2553 6.29982C14.0528 6.02149 13.6637 5.95732 13.3829 6.16232ZM18.9587 14.584C18.9587 16.5373 17.3703 18.1257 15.417 18.1257C13.4637 18.1257 11.8753 16.5373 11.8753 14.584C11.8753 12.6307 13.4637 11.0423 15.417 11.0423C17.3703 11.0423 18.9587 12.6307 18.9587 14.584ZM17.7087 14.584C17.7087 13.3198 16.6812 12.2923 15.417 12.2923C14.1528 12.2923 13.1253 13.3198 13.1253 14.584C13.1253 15.8482 14.1528 16.8757 15.417 16.8757C16.6812 16.8757 17.7087 15.8482 17.7087 14.584ZM16.042 14.3248V13.4898C16.042 13.1448 15.762 12.8648 15.417 12.8648C15.072 12.8648 14.792 13.1448 14.792 13.4898V14.5831C14.792 14.749 14.8578 14.9082 14.9753 15.0248L15.757 15.8065C15.8786 15.9281 16.0386 15.9898 16.1986 15.9898C16.3587 15.9898 16.5187 15.929 16.6403 15.8065C16.8845 15.5623 16.8845 15.1665 16.6403 14.9223L16.042 14.3248Z"
      fill={color}
    />
  </svg>
);

export default IconMailClock;
